import { ReactNode } from "react";
import GoogleMapReact from "google-map-react";
import { LocationOn } from "@mui/icons-material";
import { useTheme } from "@mui/material";

interface Coordinates {
  lat: number;
  lng: number;
}

export enum MAPTYPE {
  SATELLITE = "satellite",
  ROADMAP = "roadmap",
  HYBRID = "hybrid",
  TERRAIN = "terrain",
}

export const Marker = () => {
  const theme = useTheme();

  return <LocationOn fontSize={"large"} sx={{ color: theme.palette.primary.main }} />;
};

export const INITIAL_LOCATION = { lat: 12.115, lng: -86.2362 };

interface Props {
  width?: string;
  height?: string;
  googleApiLoaded?: (maps: { map: any; maps: any; ref: Element | null }) => void;
  children?: ReactNode;
  defaultCenter?: Coordinates;
  type?: MAPTYPE;
  defaultZoom?: number;
}

const Map = ({ width = "100%", height = "300px", googleApiLoaded, defaultCenter, children, type = MAPTYPE.SATELLITE, defaultZoom = 12 }: Props) => {
  return (
    <div style={{ height: height, width: width }}>
      <GoogleMapReact
        bootstrapURLKeys={{
          key: import.meta.env.VITE_FIREBASE_API_KEY,
        }}
        defaultCenter={defaultCenter ?? INITIAL_LOCATION}
        defaultZoom={defaultZoom}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={googleApiLoaded}
        options={{
          mapTypeId: type,
        }}
      >
        {children}
      </GoogleMapReact>
    </div>
  );
};

export default Map;
